import {
    OPEN_PRINTER_MODAL,
    CLOSE_PRINTER_MODAL,
    GET_PRINTERS,
    ADD_PRINTER,
    UPDATE_PRINTER,
    DELETE_PRINTER
} from './printer.actionTypes';

export default function orders(state = [], action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
    case OPEN_PRINTER_MODAL:
        return {
            ...newState,
            selectedPrinter: action.printer,
            showModal: true
        }
    case CLOSE_PRINTER_MODAL:
        return {
            ...newState,
            selectedPrinter: null,
            showModal: false
        }
    case GET_PRINTERS:
        return {
            ...newState,
            list: action.printers
        }
    case ADD_PRINTER:
        const list = newState.list || [];
        list.push(action.printer);
        return {
            ...newState,
            list: list
        }
    case UPDATE_PRINTER:
        newState.list = newState.list.map((printer) => {
            if (printer._id === action.printer._id) {
                return action.printer;
            }
            return printer;
        });
        return newState;
    case DELETE_PRINTER:
        newState.list = newState.list.filter((printer) => printer._id !== action.printer._id);
        return newState;
    default:
        return newState;
    }
}